import { SmallText, colors } from 'app-v2/design-systems'
import { BORDER, SPACING } from 'app-v2/design-tokens'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import React from 'react'
import mysteryBurgerBag from 'app/assets/images/mystery-burger/mystery-burger-bag.png'
import bkDaysLogo from 'app/assets/images/bk-days/bk-days-logo.png'
import bal2promo from 'app/assets/images/bal-2-promo/bal-2-promo.webp'
//$FlowFixMe
import hottingGrillLogo from 'app/assets/images/operation-repeat/hotting-grill-logo.webp'
import { FeatureToggle } from 'app/common/feature-toggle'
import { featureCodes } from 'shared/utils'

export const InfoMessage = () => {
    const intl = useIntl()

    return (
        <StyledContainer>
            <FeatureToggle feature={featureCodes.BANNIERE_WEB_BURGER_MYSTERE}>
                <StyledImage src={mysteryBurgerBag} />

                <SmallText>
                    {intl.formatMessage({
                        id: 'operation.impersonal.modal.mystery.burger'
                    })}
                </SmallText>
            </FeatureToggle>

            <FeatureToggle feature={featureCodes.BANNIERE_WEB_BK_DAYS}>
                <StyledLandscapeImage src={bkDaysLogo} />

                <SmallText>
                    {intl.formatMessage({
                        id: 'operation.impersonal.modal.bk.days'
                    })}
                </SmallText>
            </FeatureToggle>

            <FeatureToggle feature={featureCodes.BANNIERE_WEB_BAL_2_PROMO}>
                <StyledLandscapeImage src={bal2promo} />

                <SmallText>
                    {intl.formatMessage({
                        id: 'operation.impersonal.modal.bal2promo'
                    })}
                </SmallText>
            </FeatureToggle>

            <FeatureToggle feature={featureCodes.BANNIERE_WEB_OPERATION_REPEAT}>
                <StyledLandscapeImage src={hottingGrillLogo} />

                <SmallText>
                    {intl.formatMessage({
                        id: 'operation.impersonal.modal.operation.repeat'
                    })}
                </SmallText>
            </FeatureToggle>
        </StyledContainer>
    )
}

const StyledLandscapeImage = styled.img`
    width: 80px;
`

const StyledImage = styled.img`
    height: ${SPACING.XL};
    width: ${SPACING.L};
`
const StyledContainer = styled.div`
    border-radius: ${BORDER.RADIUS.M};
    background-color: ${colors.darkBrown}0f;
    display: flex;
    flex-direction: row;
    padding: ${SPACING.XS} ${SPACING.S};
    gap: ${SPACING.S};
    align-items: center;
`
